module.exports = __webpack_public_path__ + "e47325c0bcac19665ef87949a4ad5897.svg";